<template>
    <div class="dm-auth-wrapper" data-cy="dm-otp-confirmation-form">
        <div class="d-flex flex-sm-column justify-content-center">
            <div class="card shadow-sm bg-white">
                <div class="card-body">
                    <h3>{{ translate("Verify Login") }}</h3>

                    <div class="mb-4" v-if="errors.length">
                        <div
                            class="alert alert-custom alert-light-danger p-4 mb-6"
                        >
                            <div class="alert-icon">
                                <i class="las la-exclamation-triangle"></i>
                            </div>
                            <div class="alert-text">
                                <div class="fw-bolder">
                                    {{
                                        translate(
                                            "Whoops! Something went wrong.",
                                        )
                                    }}
                                </div>
                                <ul class="p-0 m-0" style="list-style: none">
                                    <li>{{ errors }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <form
                        method="POST"
                        class="dm-parsley-validate-form"
                        id="otp-confirmation-form"
                        @submit.prevent="submitOtpCode()"
                    >
                        <div>
                            <label class="form-label" for="code">
                                {{
                                    translate(
                                        "Please enter the security code you have received via email",
                                    )
                                }}
                            </label>
                            <input
                                class="form-control"
                                id="otp_code"
                                type="text"
                                name="otp_code"
                                required=""
                                :disabled="submitting"
                                autofocus=""
                                v-model="otp_code"
                                @keyup="errors = ''"
                            />
                        </div>

                        <div
                            class="d-flex align-content-center justify-content-between mt-4"
                        >
                            <button
                                type="submit"
                                class="btn dm-btn-padding dm-btn-brand ml-3 dm-login-button"
                                id="dm-submit-otp-button"
                                :disabled="submitting"
                            >
                                {{ translate("Submit") }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            submitting: false,
            errors: "",
            otp_code: "",
        };
    },

    props: ["otp_email"],

    methods: {
        submitOtpCode() {
            let confirmationData = {
                _token: document.head.querySelector('meta[name="csrf-token"]')
                    .content,
                otp_code: this.otp_code,
                email: this.otp_email,
            };

            var self = this;
            axios
                .post("/verify-otp-api", confirmationData)
                .then(function (response) {
                    self.submitting = false;

                    if (response.data.redirect_to)
                        window.location.href = response.data.redirect_to;
                })
                .catch(function (error) {
                    self.submitting = false;
                    self.errors = error.response.data.message;
                    self.otp_code = "";
                });
        },
    },
};
</script>
